import React from 'react';
import { useSelector } from 'react-redux';
import {
  ProductItemButton,
  ProductItemSecondaryButton,
} from './multiConfigStyles';
import { childIsConfigured } from './childConfiguration';

const MultiConfigProductItemCTA = ({ item, onClick }) => {
  const { product } = item;
  const isPrepay = useSelector((state) => state.shoot.isPrepay);

  // One notion of "done" for every child, so a child needing no background is
  // not stuck on its opening CTA — see childConfiguration.
  if (childIsConfigured(item, { isPrepay })) {
    return (
      <ProductItemSecondaryButton>Edit Selection</ProductItemSecondaryButton>
    );
  }

  return (
    <ProductItemButton onClick={onClick(product)}>
      {isPrepay ? 'Configure' : 'Choose Photo'}
    </ProductItemButton>
  );
};

export default MultiConfigProductItemCTA;
